/**
 * Splits a flat array of annotated text elements at a character offset.
 * Pure utility with no imports — safe to use from any module without
 * creating circular ESM dependency chains in tests.
 */
export const splitAnnotatedElementsAtOffset = <
    T extends { text?: string | null }
>(
    elements: T[],
    offset: number
): { before: T[]; after: T[] } => {
    if (offset === 0) return { before: [], after: elements }
    let accumulated = 0
    for (let i = 0; i < elements.length; i++) {
        const el = elements[i]
        const text = el.text || ''
        const next = accumulated + text.length
        if (next <= offset) {
            accumulated = next
            if (accumulated === offset) {
                return {
                    before: elements.slice(0, i + 1),
                    after: elements.slice(i + 1),
                }
            }
        } else {
            const split = offset - accumulated
            return {
                before: [
                    ...elements.slice(0, i),
                    { ...el, text: text.slice(0, split) } as T,
                ],
                after: [
                    { ...el, text: text.slice(split) } as T,
                    ...elements.slice(i + 1),
                ],
            }
        }
    }
    return { before: elements, after: [] }
}
